import { render, staticRenderFns } from "./JdsGlyph.vue?vue&type=template&id=d3339270&scoped=true&"
import script from "./JdsGlyph.vue?vue&type=script&lang=ts&"
export * from "./JdsGlyph.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3339270",
  null
  
)

export default component.exports